import { useEffect, useRef } from "react";

const BLOBS = [
  { color: "255,77,0", r: 0.45, sx: 0.22, sy: 0.28, sp: 0.00022, ph: 0, a: 0.2 },
  { color: "61,185,230", r: 0.4, sx: 0.78, sy: 0.32, sp: 0.00017, ph: 2.1, a: 0.18 },
  { color: "255,77,0", r: 0.32, sx: 0.55, sy: 0.85, sp: 0.00026, ph: 4.2, a: 0.12 },
  { color: "61,185,230", r: 0.3, sx: 0.4, sy: 0.6, sp: 0.0002, ph: 5.4, a: 0.1 },
];

export const HeroCanvas = () => {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    let raf;
    const mouse = { x: 0.5, y: 0.5, tx: 0.5, ty: 0.5 };

    const resize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };
    resize();
    window.addEventListener("resize", resize);

    const onMove = (e) => {
      mouse.tx = e.clientX / window.innerWidth;
      mouse.ty = e.clientY / window.innerHeight;
    };
    window.addEventListener("pointermove", onMove);

    const draw = (t) => {
      mouse.x += (mouse.tx - mouse.x) * 0.04;
      mouse.y += (mouse.ty - mouse.y) * 0.04;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      BLOBS.forEach((b) => {
        const x =
          (b.sx + Math.sin(t * b.sp + b.ph) * 0.1 + (mouse.x - 0.5) * 0.1) *
          canvas.width;
        const y =
          (b.sy + Math.cos(t * b.sp * 1.3 + b.ph) * 0.1 + (mouse.y - 0.5) * 0.1) *
          canvas.height;
        const r =
          b.r *
          Math.min(canvas.width, canvas.height) *
          (1 + Math.sin(t * 0.0004 + b.ph) * 0.08);
        const g = ctx.createRadialGradient(x, y, 0, x, y, r);
        g.addColorStop(0, `rgba(${b.color},${b.a})`);
        g.addColorStop(1, `rgba(${b.color},0)`);
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(x, y, r, 0, Math.PI * 2);
        ctx.fill();
      });
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("pointermove", onMove);
    };
  }, []);

  return (
    <canvas
      ref={ref}
      aria-hidden="true"
      className="absolute inset-0 h-full w-full"
    />
  );
};
